import { useSelector } from 'react-redux';
import { selectActiveCapabilities } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import type { SinatraState } from '@rsos/sinatra';
import { useUserPermissions } from '@rsos/sinatra/src/selectors';
import { useFlags } from '@rsos/utils/openFeature';
import type { SideBarMenuItem } from './types';
import { shouldSideBarItemRender } from './utils';

interface SideBarState {
  sinatra: SinatraState;
}

/**
 * Filters the sidebar items to those the current user should see, using the same
 * access descriptors and predicate that guard the routes themselves.
 *
 * Permissions come from `currentRole.permissions` rather than `pageAccessList`
 * so nav and routes read one source. Both are derived from the same role in the
 * same /user response — pageAccessList is that list filtered to the
 * `rsp_rbac: true` set — so for the page-access permissions the sidebar gates on,
 * this is equivalent.
 */
export default function useRenderSideBarItems(
  sideBarItems: SideBarMenuItem[] = [],
): SideBarMenuItem[] {
  const flags = useFlags();
  const activeCapabilities = useSelector(selectActiveCapabilities);
  const permissions = useUserPermissions();
  const application = useSelector(
    (state: SideBarState) => state.sinatra.user?.currentRole?.application,
  );

  return sideBarItems.filter(item =>
    shouldSideBarItemRender(item, {
      permissions,
      flags,
      activeCapabilities: activeCapabilities || {},
      application,
    }),
  );
}
